import { Reveal } from '../Reveal';
import { SectionHeader } from '../SectionHeader';
import { CheckList, DemoCaption } from '../compass/shared';

// Section 9 — site and customer profitability. The Site Profit & Loss
// screenshot leads; every figure is illustrative demonstration data.
export const PulseProfitability = ({ sp }) => (
  <section aria-labelledby="pulse-profitability-heading" data-testid="pulse-profitability" className="bg-white py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <SectionHeader
        index="09"
        eyebrow="Commercial Visibility"
        title="Understand the true performance of each site and customer"
        description={sp.profitCopy}
        testid="pulse-profitability-header"
      />
      <div className="mt-12 grid items-start gap-12 lg:grid-cols-5">
        <Reveal className="lg:col-span-3">
          <figure className="overflow-hidden rounded-xl border border-slate-200 bg-white shadow-lift">
            <img
              src={sp.shots.sitePl.src}
              alt={sp.shots.sitePl.alt}
              width={sp.shots.sitePl.width}
              height={sp.shots.sitePl.height}
              loading="lazy"
              className="w-full"
              data-testid="pulse-profitability-visual"
            />
          </figure>
          <DemoCaption className="text-left" />
          <p className="mt-2 text-left text-xs leading-relaxed text-slate-500">
            Operational management information based on configured data — Pulse does not replace accounting software or statutory financial accounts.
          </p>
        </Reveal>
        <Reveal delay={0.12} className="lg:col-span-2">
          <h3 className="text-sm font-bold uppercase tracking-[0.18em] text-slate-500">What the view brings together</h3>
          <div className="mt-5">
            <CheckList items={sp.profitPoints || []} testid="pulse-profit-points" />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
